import {NgModule} from '@angular/core';
import {DynamicComponentDirective} from 'fuse-core/directives/dynamic-component/dynamic-component.directive';
import {MoveElementDirective} from 'fuse-core/directives/move-element/move-element.directive';
import {DiableAutofillDirective} from '@fuse/directives/disable-autofill/disable-autofill.directive';
import {AddClassInRegardOfTextSizeDirective} from 'fuse-core/directives/add-class-in-regard-of-text-size/add-class-in-regard-of-text-size.directive';
import {AddClassIfContainsPictureDirective} from 'fuse-core/directives/add-class-if-contains-picture/add-class-if-contains-picture.directive';
import {AddClassInRegardOfTextHeightDirective} from 'fuse-core/directives/add-class-in-regard-of-text-height/add-class-in-regard-of-text-height.directive';
import { DayRelativeNameToStringDirective } from '@fuse/directives/day-relative-name-to-string/day-relative-name-to-string.directive';
import { TimeSlotToStringDirective } from '@fuse/directives/time-slot-to-string/time-slot-to-string.directive';
import {MoveFocusToNextAllowedElementDirective} from 'fuse-core/directives/move-focus-to-next-allowed-element/move-focus-to-next-allowed-element.directive';

@NgModule({
    declarations: [
        DynamicComponentDirective,
        MoveElementDirective,
        DiableAutofillDirective,
        AddClassInRegardOfTextSizeDirective,
        AddClassInRegardOfTextHeightDirective,
        AddClassIfContainsPictureDirective,
        DayRelativeNameToStringDirective,
        TimeSlotToStringDirective,
        MoveFocusToNextAllowedElementDirective
    ],
    imports: [],
    exports: [
        DynamicComponentDirective,
        MoveElementDirective,
        DiableAutofillDirective,
        AddClassInRegardOfTextSizeDirective,
        AddClassInRegardOfTextHeightDirective,
        AddClassIfContainsPictureDirective,
        DayRelativeNameToStringDirective,
        TimeSlotToStringDirective,
        MoveFocusToNextAllowedElementDirective
    ],
})
export class FuseDirectivesModule {
}
